import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ptBR as pickersPtBR } from '@mui/x-date-pickers/locales';
import { ptBR } from 'date-fns/locale';
import storage from 'local-storage-fallback';
import React, { createContext, useContext, useEffect, useReducer } from 'react';
import { ThemeProvider } from 'styled-components';
import GlobalStyle from './GlobalStyle';
import muiTheme, { MuiGlobalCss } from './muiTheme';

const KskContext = createContext(null);

export const KSK_ACTIONS = {
  CHANGE_MODE: 'changeMode',
  CHANGE_TEXT_ZOOM: 'changeTextZoom'
};

const defaultTheme = {
  mode: 'padrao',
  textZoom: 'normal'
};

function reducer(state, action) {
  switch (action.type) {
    case KSK_ACTIONS.CHANGE_MODE:
      return { ...state, mode: action.payload };

    case KSK_ACTIONS.CHANGE_TEXT_ZOOM:
      return { ...state, textZoom: action.payload };

    default:
      return state;
  }
}

function getInitialTheme() {
  const saved = storage.getItem('theme');
  return saved ? JSON.parse(saved) : defaultTheme;
}

export function useKsk() {
  const context = useContext(KskContext);
  if (!context) {
    throw new Error('useKsk must be used inside KskProvider');
  }
  return context;
}

export function KskProvider({ children }) {
  const [theme, dispatch] = useReducer(reducer, undefined, getInitialTheme);

  useEffect(() => {
    storage.setItem('theme', JSON.stringify(theme));
  }, [theme]);

  return (
    <KskContext.Provider value={{ theme, dispatch }}>
      <ThemeProvider theme={theme}>
        <MuiThemeProvider theme={muiTheme}>
          <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={ptBR}
            localeText={pickersPtBR.components.MuiLocalizationProvider.defaultProps.localeText}
          >
            <GlobalStyle />
            <MuiGlobalCss />
            {children}
          </LocalizationProvider>
        </MuiThemeProvider>
      </ThemeProvider>
    </KskContext.Provider>
  );
}
